import { controls } from "../../controls";

const rp808 = {
  label: "Dividend Scroll",
  pageLabel: "Dividend Scroll",
  starting: true,
  url: "rp808",

  pageType: "history",
  filter: [

    ...controls.displayText({ tab: "filter", label: "Warrant Year", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "warrant_year", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),

    ...controls.checkBox({ tab: "filter", label: "Reginal Name", name: "reginal_name", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-12" }),

    ...controls.displayText({ tab: "filter", label: "From-To Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "date_from", isRequired: true, width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", star: true, width: "col-sm-0 " }),
    ...controls.magicDate({ tab: "filter", name: "date_to", isRequired: true, width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-12" }),

    ...controls.displayText({ tab: "filter", label: "Member Type", star: true, width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", isRequired: true, placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "Member Number From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_from", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_to", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "Amount From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_from", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_to", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "Trancation Type", star: true, width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", isRequired: true, defaultValue: "",
      options: [{
        label: "All",
        value: "all"
      },
      {
        label: "Cash",
        value: "cash"
      },

      {
        label: "Transfer",
        value: "transfer"
      },


      {
        label: "Clearing",
        value: "clearning"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "Member from Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter' }),







  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Dividend Scroll",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },

      {
        Header: "Date",
        accessor: "date",

      },

      {
        Header: "Member No",
        accessor: "member_no"

      },

      {
        Header: "CIN",
        accessor: "cin",

      },

      {
        Header: "Member Name",
        accessor: "member_name",

      },

      {
        Header: "War No",
        accessor: "war_no",

      },

      {
        Header: "Dividend",
        accessor: "dividend",
        type: "currancy"
      },

      {
        Header: "No Of Shares",
        accessor: "no_of_shars",

      },

      {
        Header: "Balance",
        accessor: "balance",
        type: "currancy"
      },

      {
        Header: "Paid Date",
        accessor: "paid_date",

      },

      {
        Header: "Remarks",
        accessor: "remarks",

      },



      {
        Header: "Transfer To",
        accessor: "Transfer_to",

      },

      {
        Header: "Transfer To Name",
        accessor: "Transfer_to_name",

      },

    ]
  }
};

export default rp808;